{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% சேமிக்கவும்)",
    "{amount} days free": "{amount} நாட்கள் இலவசம்",
    "{amount} off": "{amount} தள்ளுபடி",
    "{amount} off for first {number} months.": "முதல் {number} மாதங்களுக்கு {amount} தள்ளுபடி.",
    "{amount} off for first {period}.": "முதல் {period}க்கு {amount} தள்ளுபடி.",
    "{amount} off forever.": "என்றென்றும் {amount} தள்ளுபடி.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% தள்ளுபடி",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} இனி {newsletterName} செய்திமடலைப் பெறமாட்டார்.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} இனி உங்கள் கருத்துகளுக்கு யாராவது பதிலளித்தால் மின்னஞ்சல்களைப் பெறமாட்டார்.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} இனி இந்த செய்திமடலைப் பெறமாட்டார்.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} நாட்கள் இலவசம்",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "கணக்கு",
    "Account details updated successfully": "கணக்கு விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன",
    "Account settings": "கணக்கு அமைப்புகள்",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "இலவச சோதனை முடிந்தபின், நீங்கள் தேர்ந்தெடுத்த அடுக்குக்கான வழக்கமான விலை உங்களிடம் வசூலிக்கப்படும். அதற்கு முன் எப்போது வேண்டுமானாலும் நீங்கள் ரத்து செய்யலாம்.",
    "Already a member?": "ஏற்கனவே உறுப்பினரா?",
    "An error occurred": "ஒரு பிழை ஏற்பட்டது",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "எதிர்பாராத பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும் அல்லது பிழை தொடர்ந்தால் <a>ஆதரவைத் தொடர்பு கொள்ளவும்</a>.",
    "Back": "பின்செல்",
    "Back to Log in": "உள்நுழைவுக்குத் திரும்பு",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "கருப்பு வெள்ளி",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "எப்போது வேண்டுமானாலும் ரத்து செய்யலாம்.",
    "Cancel subscription": "சந்தாவை ரத்து செய்",
    "Canceled": "",
    "Cancellation reason": "ரத்து செய்யும் காரணம்",
    "Change": "மாற்று",
    "Change plan": "திட்டத்தை மாற்று",
    "Check spam & promotions folders": "ஸ்பாம் & விளம்பர கோப்புறைகளை சரிபார்க்கவும்",
    "Check with your mail provider": "உங்கள் அஞ்சல் வழங்குநரிடம் சரிபார்க்கவும்",
    "Check your inbox to verify email update": "மின்னஞ்சல் புதுப்பிப்பை சரிபார்க்க உங்கள் உள்பெட்டியைச் சரிபார்க்கவும்",
    "Choose": "தேர்வு செய்",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "வேறு திட்டத்தைத் தேர்வு செய்யவும்",
    "Choose a plan": "ஒரு திட்டத்தைத் தேர்வு செய்யவும்",
    "Choose a tier": "",
    "Choose your newsletters": "உங்கள் செய்திமடல்களைத் தேர்வு செய்யவும்",
    "City": "",
    "Click here to retry": "மீண்டும் முயற்சிக்க இங்கே கிளிக் செய்யவும்",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "மூடு",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "கருத்துகள்",
    "Complimentary": "இலவசம்",
    "Confirm": "உறுதிப்படுத்து",
    "Confirm cancellation": "ரத்து செய்வதை உறுதிப்படுத்து",
    "Confirm subscription": "சந்தாவை உறுதிப்படுத்து",
    "Contact support": "ஆதரவைத் தொடர்பு கொள்ளவும்",
    "Continue": "தொடரவும்",
    "Continue subscription": "சந்தாவைத் தொடரவும்",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "ஸ்ட்ரைப் செக்அவுட் அமர்வை உருவாக்க முடியவில்லை",
    "Could not sign in. Login link expired.": "உள்நுழைய முடியவில்லை. உள்நுழைவு இணைப்பு காலாவதியானது.",
    "Could not update email! Invalid link.": "மின்னஞ்சலை புதுப்பிக்க முடியவில்லை! தவறான இணைப்பு.",
    "Country": "",
    "Create a new contact": "புதிய தொடர்பை உருவாக்கு",
    "Current plan": "தற்போதைய திட்டம்",
    "Delete account": "கணக்கை நீக்கு",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "இதைச் செய்ய விரும்பவில்லையா? உங்கள் விருப்பங்களை <button>இங்கே</button> நிர்வகிக்கவும்.",
    "Don't have an account?": "கணக்கு இல்லையா?",
    "Edit": "திருத்து",
    "Email": "மின்னஞ்சல்",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "மின்னஞ்சல் செய்திமடல்",
    "Email newsletter settings updated": "மின்னஞ்சல் செய்திமடல் அமைப்புகள் புதுப்பிக்கப்பட்டன",
    "Email preferences": "மின்னஞ்சல் விருப்பங்கள்",
    "Email preferences updated.": "",
    "Emails": "மின்னஞ்சல்கள்",
    "Emails disabled": "மின்னஞ்சல்கள் முடக்கப்பட்டன",
    "Ends {offerEndDate}": "{offerEndDate} முடிவடைகிறது",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    "Enter your name": "உங்கள் பெயரை உள்ளிடவும்",
    "Error": "பிழை",
    "Expires {expiryDate}": "{expiryDate} காலாவதியாகிறது",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "சந்தாவை ரத்து செய்ய முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    "Failed to log in, please try again": "உள்நுழைய முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    "Failed to log out, please try again": "வெளியேற முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "செக்அவுட்டை செயலாக்க முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    "Failed to send magic link email": "மேஜிக் லிங்க் மின்னஞ்சலை அனுப்ப முடியவில்லை",
    "Failed to send verification email": "சரிபார்ப்பு மின்னஞ்சலை அனுப்ப முடியவில்லை",
    "Failed to sign up, please try again": "பதிவு செய்ய முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    "Failed to update account data": "கணக்கு தரவை புதுப்பிக்க முடியவில்லை",
    "Failed to update account details": "கணக்கு விவரங்களை புதுப்பிக்க முடியவில்லை",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "செய்திமடல் அமைப்புகளை புதுப்பிக்க முடியவில்லை",
    "Failed to update subscription, please try again": "சந்தாவை புதுப்பிக்க முடியவில்லை, மீண்டும் முயற்சிக்கவும்",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "என்றென்றும்",
    "Free Trial – Ends {trialEnd}": "இலவச சோதனை - {trialEnd} முடிவடைகிறது",
    "From": "",
    "Get help": "உதவி பெறுங்கள்",
    "Get in touch for help": "உதவிக்கு தொடர்பு கொள்ளுங்கள்",
    "Get notified when someone replies to your comment": "யாராவது உங்கள் கருத்துக்கு பதிலளித்தால் அறிவிப்பு பெறுங்கள்",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "இந்த இடுகையில் கருத்து தெரிவிக்கவும்",
    "Help! I'm not receiving emails": "உதவி! நான் மின்னஞ்சல்களைப் பெறவில்லை",
    "Here are a few other sites you may enjoy.": "நீங்கள் ரசிக்கக்கூடிய சில பிற தளங்கள் இங்கே.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "ஒரு செய்திமடல் ஸ்பாம் என குறிக்கப்பட்டால், நீங்கள் மேலும் எந்த தேவையற்ற செய்திகளையும் பெறாமல் இருப்பதை உறுதிசெய்ய அந்த முகவரிக்கான மின்னஞ்சல்கள் தானாகவே முடக்கப்படும்.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "ஸ்பாம் புகார் தற்செயலாக இருந்தால், அல்லது நீங்கள் மீண்டும் மின்னஞ்சல்களைப் பெற விரும்பினால், முந்தைய திரையில் உள்ள பொத்தானைக் கிளிக் செய்வதன் மூலம் மின்னஞ்சல்களுக்கு மீண்டும் சந்தா செய்யலாம்.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "நீங்கள் இப்போது உங்கள் சந்தாவை ரத்து செய்தால், {periodEnd} வரை தொடர்ந்து அணுகல் இருக்கும்.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "உங்களிடம் கார்ப்பரேட் அல்லது அரசு மின்னஞ்சல் கணக்கு இருந்தால், உங்கள் IT துறையை தொடர்பு கொண்டு {senderEmail} இலிருந்து மின்னஞ்சல்களைப் பெற அனுமதிக்குமாறு கேளுங்கள்",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "உங்கள் உள்பெட்டிக்கு ஒரு உள்நுழைவு இணைப்பு அனுப்பப்பட்டுள்ளது. 3 நிமிடங்களில் அது வரவில்லை என்றால், உங்கள் ஸ்பாம் கோப்புறையைச் சரிபார்க்கவும்.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "நீங்கள் மீண்டும் மின்னஞ்சல்களைப் பெற விரும்பினால், அடுத்த சிறந்த படிகள் உங்கள் பதிவில் உள்ள மின்னஞ்சல் முகவரியை ஏதேனும் சிக்கல்களுக்காக சரிபார்த்து, பின்னர் முந்தைய திரையில் மீண்டும் சந்தா செய்யவும் என்பதைக் கிளிக் செய்வதாகும்.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "நீங்கள் சந்தா செய்துள்ள மின்னஞ்சல் செய்திமடலைப் பெறவில்லை என்றால், இங்கே சரிபார்க்க சில விஷயங்கள் உள்ளன.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "நீங்கள் இந்த அனைத்து சரிபார்ப்புகளையும் முடித்துவிட்டு, இன்னும் மின்னஞ்சல்களைப் பெறவில்லை என்றால், {supportAddress} ஐத் தொடர்பு கொண்டு ஆதரவைப் பெறலாம்.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "ஒரு செய்திமடலை அனுப்ப முயற்சிக்கும்போது நிரந்தர தோல்வி ஏற்பட்டால், கணக்கில் மின்னஞ்சல்கள் முடக்கப்படும்.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "உங்கள் மின்னஞ்சல் கிளையன்டில் {senderEmail} ஐ உங்கள் தொடர்புகள் பட்டியலில் சேர்க்கவும். இந்த முகவரியிலிருந்து அனுப்பப்படும் மின்னஞ்சல்கள் நம்பகமானவை என்று உங்கள் அஞ்சல் வழங்குநருக்கு இது சமிக்ஞை காட்டுகிறது.",
    "Invalid email address": "தவறான மின்னஞ்சல் முகவரி",
    "Invalid verification code": "",
    "Jamie Larson": "ஜேமி லார்சன்",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "இது போன்று குறைவாக",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "மின்னஞ்சல்கள் தற்செயலாக உங்கள் உள்பெட்டியின் ஸ்பாம் அல்லது விளம்பரங்கள் கோப்புறைகளில் முடிவடையவில்லை என்பதை உறுதிப்படுத்தவும். அவை இருந்தால், \"ஸ்பாம் அல்ல என குறி\" மற்றும்/அல்லது \"உள்பெட்டிக்கு நகர்த்து\" என்பதைக் கிளிக் செய்யவும்.",
    "Manage": "நிர்வகி",
    "Maybe later": "ஒருவேளை பிறகு",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "உறுப்பினர்கள் கிடைக்கவில்லை, அணுகலுக்கு உரிமையாளரைத் தொடர்பு கொள்ளவும்.",
    "month": "மாதம்",
    "Monthly": "மாதாந்திர",
    "More like this": "இது போன்று அதிகமாக",
    "More options": "",
    "Name": "பெயர்",
    "Need more help? Contact support": "மேலும் உதவி தேவையா? ஆதரவைத் தொடர்பு கொள்ளவும்",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "இரண்டு காரணங்களுக்காக உங்கள் கணக்கில் செய்திமடல்கள் முடக்கப்படலாம்: முந்தைய மின்னஞ்சல் ஸ்பாம் என குறிக்கப்பட்டது, அல்லது மின்னஞ்சலை அனுப்ப முயற்சிப்பது நிரந்தர தோல்வியில் முடிந்தது (பவுன்ஸ்).",
    "No member exists with this e-mail address.": "இந்த மின்னஞ்சல் முகவரியுடன் எந்த உறுப்பினரும் இல்லை.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "மின்னஞ்சல்களைப் பெறவில்லையா?",
    "Now": "",
    "Now check your email!": "இப்போது உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "மீண்டும் சந்தா செய்த பிறகும், உங்கள் உள்பெட்டியில் மின்னஞ்சல்களைக் காணவில்லை என்றால், உங்கள் ஸ்பாம் கோப்புறையைச் சரிபார்க்கவும். சில உள்பெட்டி வழங்குநர்கள் முந்தைய ஸ்பாம் புகார்களின் பதிவை வைத்திருப்பார்கள் மற்றும் மின்னஞ்சல்களை தொடர்ந்து கொடியிடுவார்கள். இது நடந்தால், சமீபத்திய செய்திமடலை 'ஸ்பாம் அல்ல' என்று குறிக்கவும், இது அதை உங்கள் முதன்மை உள்பெட்டிக்கு திருப்பி அனுப்பும்.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "நிரந்தர தோல்வி (பவுன்ஸ்)",
    "Phone number": "தொலைபேசி எண்",
    "Plan": "திட்டம்",
    "Plan checkout was cancelled.": "திட்ட செக்அவுட் ரத்து செய்யப்பட்டது.",
    "Plan upgrade was cancelled.": "திட்ட மேம்படுத்தல் ரத்து செய்யப்பட்டது.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "உங்கள் இலவச சந்தாவை சரிசெய்ய {supportAddress} ஐத் தொடர்பு கொள்ளவும்.",
    "Please enter {fieldName}": "{fieldName} ஐ உள்ளிடவும்",
    "Please fill in required fields": "தேவையான புலங்களை நிரப்பவும்",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "மின்னஞ்சல்களை மீண்டும் இயக்கு",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "பரிந்துரைகள்",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price}க்கு புதுப்பிக்கப்படுகிறது.",
    "Resume subscription": "",
    "Retry": "மீண்டும் முயற்சி",
    "Save": "சேமி",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "உள்நுழைவு இணைப்பை அனுப்புகிறது...",
    "Sending...": "அனுப்புகிறது...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "அனைத்தையும் காட்டு",
    "Sign in": "உள்நுழைக",
    "Sign out": "வெளியேறு",
    "Sign up": "பதிவு செய்",
    "Signup error: Invalid link": "பதிவு பிழை: தவறான இணைப்பு",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "ஏதோ தவறு நடந்துவிட்டது, பிறகு மீண்டும் முயற்சிக்கவும்.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "மன்னிக்கவும், அது வேலை செய்யவில்லை.",
    "Spam complaints": "ஸ்பாம் புகார்கள்",
    "Start {amount}-day free trial": "{amount}-நாள் இலவச சோதனையைத் தொடங்கு",
    "Starting {startDate}": "{startDate} முதல் தொடங்குகிறது",
    "Starting today": "இன்று முதல் தொடங்குகிறது",
    "State": "",
    "Submit feedback": "கருத்தை சமர்ப்பிக்கவும்",
    "Subscribe": "சந்தா செய்",
    "Subscribed": "சந்தா செய்யப்பட்டது",
    "Subscription plan updated successfully": "சந்தா திட்டம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    "Success": "வெற்றி",
    "Success! Check your email for magic link to sign-in.": "வெற்றி! உள்நுழைய மேஜிக் இணைப்புக்காக உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்.",
    "Success! Your account is fully activated, you now have access to all content.": "வெற்றி! உங்கள் கணக்கு முழுமையாக செயல்படுத்தப்பட்டுள்ளது, இப்போது உங்களுக்கு அனைத்து உள்ளடக்கத்திற்கும் அணுகல் உள்ளது.",
    "Success! Your email is updated.": "வெற்றி! உங்கள் மின்னஞ்சல் புதுப்பிக்கப்பட்டது.",
    "Successfully unsubscribed": "வெற்றிகரமாக சந்தா நீக்கப்பட்டது",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "சந்தா செய்ததற்கு நன்றி. நீங்கள் படிக்கத் தொடங்குவதற்கு முன், கீழே நீங்கள் ரசிக்கக்கூடிய சில பிற தளங்கள் உள்ளன.",
    "Thank you for your support": "உங்கள் ஆதரவுக்கு நன்றி",
    "Thank you for your support!": "உங்கள் ஆதரவுக்கு நன்றி!",
    "Thanks for the feedback!": "கருத்துக்கு நன்றி!",
    "That didn't go to plan": "அது திட்டமிட்டபடி நடக்கவில்லை",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "உங்களுக்காக எங்களிடம் உள்ள மின்னஞ்சல் முகவரி {memberEmail} - அது சரியாக இல்லை என்றால், நீங்கள் அதை உங்கள் <button>கணக்கு அமைப்புகள் பகுதியில்</button> புதுப்பிக்கலாம்.",
    "There was a problem submitting your feedback. Please try again a little later.": "உங்கள் கருத்தை சமர்ப்பிப்பதில் சிக்கல் ஏற்பட்டது. சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
    "There was an error cancelling your subscription, please try again.": "உங்கள் சந்தாவை ரத்து செய்வதில் பிழை ஏற்பட்டது, மீண்டும் முயற்சிக்கவும்.",
    "There was an error continuing your subscription, please try again.": "உங்கள் சந்தாவைத் தொடர்வதில் பிழை ஏற்பட்டது, மீண்டும் முயற்சிக்கவும்.",
    "There was an error processing your payment. Please try again.": "உங்கள் கட்டணத்தை செயலாக்குவதில் பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
    "There was an error sending the email, please try again": "மின்னஞ்சலை அனுப்புவதில் பிழை ஏற்பட்டது, மீண்டும் முயற்சிக்கவும்",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "இந்த தளம் அழைப்பு மட்டுமே, அணுகலுக்கு உரிமையாளரைத் தொடர்பு கொள்ளவும்.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "இந்த தளம் தற்போது கட்டணங்களை ஏற்கவில்லை.",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "பதிவை முடிக்க, உங்கள் உள்பெட்டியில் உள்ள உறுதிப்படுத்தல் இணைப்பைக் கிளிக் செய்யவும். 3 நிமிடங்களுக்குள் அது வரவில்லை என்றால், உங்கள் ஸ்பாம் கோப்புறையைச் சரிபார்க்கவும்!",
    "To continue to stay up to date, subscribe to {publication} below.": "தொடர்ந்து புதுப்பிக்கப்பட்டிருக்க, கீழே உள்ள {publication}க்கு சந்தா செய்யுங்கள்.",
    "Too many attempts try again in {number} days.": "மிக அதிகமான முயற்சிகள் {number} நாட்களில் மீண்டும் முயற்சிக்கவும்.",
    "Too many attempts try again in {number} hours.": "மிக அதிகமான முயற்சிகள் {number} மணிநேரங்களில் மீண்டும் முயற்சிக்கவும்.",
    "Too many attempts try again in {number} minutes.": "மிக அதிகமான முயற்சிகள் {number} நிமிடங்களில் மீண்டும் முயற்சிக்கவும்.",
    "Too many different sign-in attempts, try again in {number} days": "மிக அதிகமான வேறுபட்ட உள்நுழைவு முயற்சிகள், {number} நாட்களில் மீண்டும் முயற்சிக்கவும்",
    "Too many different sign-in attempts, try again in {number} hours": "மிக அதிகமான வேறுபட்ட உள்நுழைவு முயற்சிகள், {number} மணிநேரங்களில் மீண்டும் முயற்சிக்கவும்",
    "Too many different sign-in attempts, try again in {number} minutes": "மிக அதிகமான வேறுபட்ட உள்நுழைவு முயற்சிகள், {number} நிமிடங்களில் மீண்டும் முயற்சிக்கவும்",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "{amount} நாட்களுக்கு இலவசமாக முயற்சிக்கவும், பின்னர் {originalPrice}.",
    "Unable to initiate checkout session": "செக்அவுட் அமர்வைத் தொடங்க முடியவில்லை",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "பணம் செலுத்தும் சந்தாதாரராக மாறி அனைத்து செய்திமடல்களுக்கும் அணுகலைத் திறக்கவும்.",
    "Unsubscribe from all emails": "அனைத்து மின்னஞ்சல்களிலிருந்தும் சந்தா நீக்கு",
    "Unsubscribed": "சந்தா நீக்கப்பட்டது",
    "Unsubscribed from all emails.": "அனைத்து மின்னஞ்சல்களிலிருந்தும் சந்தா நீக்கப்பட்டது.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "மின்னஞ்சல்களிலிருந்து சந்தா நீக்குவது {title}க்கான உங்கள் பணம் செலுத்திய சந்தாவை ரத்து செய்யாது",
    "Update": "புதுப்பி",
    "Update your preferences": "உங்கள் விருப்பங்களை புதுப்பிக்கவும்",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "சரிபார்ப்பு இணைப்பு அனுப்பப்பட்டது, உங்கள் உள்பெட்டியைச் சரிபார்க்கவும்",
    "Verify your email address is correct": "உங்கள் மின்னஞ்சல் முகவரி சரியானதா என்பதை சரிபார்க்கவும்",
    "Verifying...": "",
    "View plans": "திட்டங்களைக் காண்க",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "மின்னஞ்சல் முகவரி காணப்படவில்லை என்பதால் உங்களை சந்தா நீக்க முடியவில்லை. தயவுசெய்து தள உரிமையாளரைத் தொடர்பு கொள்ளவும்.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "மீண்டும் வரவேற்கிறோம், {name}!",
    "Welcome back!": "மீண்டும் வரவேற்கிறோம்!",
    "Welcome to {siteTitle}": "{siteTitle}க்கு வரவேற்கிறோம்",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "ஒரு உள்பெட்டி மின்னஞ்சலை ஏற்க தவறும்போது அது பொதுவாக பவுன்ஸ் என்று அழைக்கப்படுகிறது. பல சந்தர்ப்பங்களில், இது தற்காலிகமாக இருக்கலாம். இருப்பினும், சில சந்தர்ப்பங்களில், மின்னஞ்சல் முகவரி தவறானதாக அல்லது இல்லாததாக இருக்கும்போது, பவுன்ஸ் செய்யப்பட்ட மின்னஞ்சல் நிரந்தர தோல்வியாக திருப்பி அனுப்பப்படலாம்.",
    "Why has my email been disabled?": "ஏன் எனது மின்னஞ்சல் முடக்கப்பட்டுள்ளது?",
    "X (Twitter)": "",
    "year": "ஆண்டு",
    "Yearly": "வருடாந்திர",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "தற்போது உங்களுக்கு இலவச உறுப்பினர் உள்ளது, முழு அணுகலுக்கு பணம் செலுத்தும் சந்தாவிற்கு மேம்படுத்தவும்.",
    "You have been successfully resubscribed": "நீங்கள் வெற்றிகரமாக மீண்டும் சந்தா செய்யப்பட்டுள்ளீர்கள்",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "நீங்கள் தற்போது மின்னஞ்சல்களைப் பெறவில்லை",
    "You're not receiving emails": "நீங்கள் மின்னஞ்சல்களைப் பெறவில்லை",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "நீங்கள் சமீபத்திய செய்தியை ஸ்பாம் என குறித்திருப்பதால் அல்லது உங்கள் வழங்கப்பட்ட மின்னஞ்சல் முகவரிக்கு செய்திகளை அனுப்ப முடியவில்லை என்பதால் நீங்கள் மின்னஞ்சல்களைப் பெறவில்லை.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "நீங்கள் வெற்றிகரமாக உள்நுழைந்துள்ளீர்கள்.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "நீங்கள் வெற்றிகரமாக சந்தா செய்துள்ளீர்கள் <strong>{siteTitle}</strong>",
    "Your account": "உங்கள் கணக்கு",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "உங்கள் மின்னஞ்சல் மீண்டும் சந்தா செய்ய முடியவில்லை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "உங்கள் உள்ளீடு வெளியிடப்படுவதை வடிவமைக்க உதவுகிறது.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "உங்கள் சந்தா {expiryDate} அன்று காலாவதியாகும்",
    "Your subscription will renew on {renewalDate}": "உங்கள் சந்தா {renewalDate} அன்று புதுப்பிக்கப்படும்",
    "Your subscription will start on {subscriptionStart}": "உங்கள் சந்தா {subscriptionStart} அன்று தொடங்கும்"
}
